import { render, staticRenderFns } from "./AdmissionExaminationRoomTeacher.vue?vue&type=template&id=43ad1b27&"
import script from "./AdmissionExaminationRoomTeacher.vue?vue&type=script&lang=js&"
export * from "./AdmissionExaminationRoomTeacher.vue?vue&type=script&lang=js&"
import style0 from "./AdmissionExaminationRoomTeacher.vue?vue&type=style&index=0&id=43ad1b27&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports